import {
    SEARCH_BIKES_REQUEST, SEARCH_BIKES_SUCCESS, SEARCH_BIKES_FAILURE,
    SEARCH_BIKE_BRAND_REQUEST, SEARCH_BIKE_BRAND_SUCCESS, SEARCH_BIKE_BRAND_FAILURE,
    SEARCH_BIKE_MODELS_REQUEST, SEARCH_BIKE_MODELS_SUCCESS, SEARCH_BIKE_MODELS_FAILURE,
    SEARCH_BIKES_COUNT_REQUEST, SEARCH_BIKES_COUNT_SUCCESS, SEARCH_BIKES_COUNT_FAILURE,
} from '../constants/search_bikes.constants';

export const setBikeManagementKey = params => ({
    type: 'SET_BIKE_MANAGEMENT_KEY',
    params,
});

export const setBikeManagementFilter = params => ({
    type: 'SET_BIKE_MANAGEMENT_FILTER',
    params,
});

export const searchBikeBrandRequest = searchText => ({
    type: SEARCH_BIKE_BRAND_REQUEST,
    searchText,
});

export const searchBikeBrandSuccess = payload => ({
    type: SEARCH_BIKE_BRAND_SUCCESS, payload,
});

export const searchBikeBrandFailure = error => ({
    type: SEARCH_BIKE_BRAND_FAILURE,
    error,
});


export const searchBikeModelsRequest = (searchText, brand_id) => ({
    type: SEARCH_BIKE_MODELS_REQUEST,
    searchText,
    brand_id,
});

export const searchBikeModelsSuccess = payload => ({
    type: SEARCH_BIKE_MODELS_SUCCESS, payload,
});

export const searchBikeModelsFailure = error => ({
    type: SEARCH_BIKE_MODELS_FAILURE,
    error,
});


export const searchBikesRequest = params => ({
    type: SEARCH_BIKES_REQUEST, params,
});

export const searchBikesSuccess = payload => ({
    type: SEARCH_BIKES_SUCCESS, payload,
});

export const searchBikesFailure = error => ({
    type: SEARCH_BIKES_FAILURE, error,
});

export const searchBikesCountRequest = params => ({
    type: SEARCH_BIKES_COUNT_REQUEST, params,
});

export const searchBikesCountSuccess = payload => ({
    type: SEARCH_BIKES_COUNT_SUCCESS, payload,
});

export const searchBikesCountFailure = error => ({
    type: SEARCH_BIKES_COUNT_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/actions/search_bikes.actions.js